/* =========================================================================
   Bundled Pilgrimage 1 "Learning the Faith" — an EXACT client mirror of the
   db/017 seed (production/db/017_pilgrimages.sql §2). Used offline / for guests /
   when GET /api/pilgrimage/p1 returns 503 (migrations not yet run). Keys, titles,
   TheoLineKeys, GateCriteriaJson, RewardJson and NodeX/NodeY percentages match
   the SQL row-for-row so the map and gate evaluation are identical online or off.

   Source of truth: db/017 lines 79-109 (10 steps) + line 67-69 (header +
   completion reward {cents:100000}). Cents rewards are granted SERVER-side for
   accounts (usp_PilgrimageStep_Complete); the client grants only the collectible
   + item locally in v1.1.0 (architecture §5 / brief §3 ruling).
   ========================================================================= */
import type { Pilgrimage } from '../api';

export const BUNDLED_P1: Pilgrimage = {
  key: 'p1',
  title: 'Learning the Faith',
  descr:
    'Your first pilgrimage — walk the fundamentals of the faith and gather the Apostles along the way.',
  mapAssetKey: 'media/p1-map.png',
  introAssetKey: 'media/p1-intro.mp4',
  completionRewardJson: '{"cents":100000}',
  steps: [
    {
      key: 'p1_first_prayer',
      title: 'A Journey Begins',
      theoLineKey: 'p1-step',
      gateCriteriaJson: '{"trigger":"SessionCompleted","conditions":[{"metric":"Count","operator":">=","value":1}]}',
      rewardJson: '{"collectible":"apostle_peter","cents":10000}',
      nodeX: 12,
      nodeY: 82,
      completedUtc: null,
    },
    {
      key: 'p1_doctrine',
      title: 'Foundations of Doctrine',
      theoLineKey: 'p1-step',
      gateCriteriaJson:
        '{"trigger":"QuestionAnswered","conditions":[{"metric":"Category","operator":"==","value":"Doctrine"},{"metric":"Count","operator":">=","value":15}]}',
      rewardJson: '{"collectible":"apostle_andrew","cents":10000}',
      nodeX: 24,
      nodeY: 68,
      completedUtc: null,
    },
    {
      key: 'p1_scripture',
      title: 'Opening the Scriptures',
      theoLineKey: 'p1-step',
      gateCriteriaJson:
        '{"trigger":"QuestionAnswered","conditions":[{"metric":"Category","operator":"==","value":"Bible"},{"metric":"Count","operator":">=","value":15}]}',
      rewardJson: '{"collectible":"apostle_james_great","cents":10000}',
      nodeX: 38,
      nodeY: 74,
      completedUtc: null,
    },
    {
      key: 'p1_saints',
      title: 'Company of the Saints',
      theoLineKey: 'p1-step',
      gateCriteriaJson:
        '{"trigger":"QuestionAnswered","conditions":[{"metric":"Category","operator":"==","value":"Saints"},{"metric":"Count","operator":">=","value":15}]}',
      rewardJson: '{"collectible":"apostle_john","cents":10000}',
      nodeX: 50,
      nodeY: 60,
      completedUtc: null,
    },
    {
      key: 'p1_liturgy',
      title: 'The Sacred Liturgy',
      theoLineKey: 'p1-step',
      gateCriteriaJson:
        '{"trigger":"QuestionAnswered","conditions":[{"metric":"Category","operator":"==","value":"Liturgy"},{"metric":"Count","operator":">=","value":10}]}',
      rewardJson: '{"collectible":"apostle_philip","cents":10000}',
      nodeX: 62,
      nodeY: 66,
      completedUtc: null,
    },
    {
      key: 'p1_popes',
      title: 'Chair of St. Peter',
      theoLineKey: 'p1-step',
      gateCriteriaJson:
        '{"trigger":"QuestionAnswered","conditions":[{"metric":"Category","operator":"==","value":"Popes"},{"metric":"Count","operator":">=","value":10}]}',
      rewardJson: '{"collectible":"apostle_bartholomew","cents":10000}',
      nodeX: 70,
      nodeY: 52,
      completedUtc: null,
    },
    {
      key: 'p1_arcade',
      title: 'A Joyful Rest',
      theoLineKey: 'p1-step',
      gateCriteriaJson: '{"trigger":"ArcadePlayed","conditions":[{"metric":"Count","operator":">=","value":1}]}',
      rewardJson: '{"collectible":"apostle_thomas","item":"arcade_ticket","qty":1}',
      nodeX: 78,
      nodeY: 40,
      completedUtc: null,
    },
    {
      key: 'p1_feast',
      title: 'Meeting a Saint',
      theoLineKey: 'p1-step',
      gateCriteriaJson: '{"trigger":"FeastVisited","conditions":[{"metric":"Count","operator":">=","value":1}]}',
      rewardJson: '{"collectible":"apostle_matthew","cents":10000}',
      nodeX: 84,
      nodeY: 30,
      completedUtc: null,
    },
    {
      key: 'p1_companion',
      title: 'A Word with a Friend',
      theoLineKey: 'p1-step',
      gateCriteriaJson: '{"trigger":"GtkyAnswered","conditions":[{"metric":"Count","operator":">=","value":1}]}',
      rewardJson: '{"collectible":"apostle_james_less","cents":10000}',
      nodeX: 88,
      nodeY: 20,
      completedUtc: null,
    },
    {
      key: 'p1_restore_altar',
      title: 'Restore the Altar',
      theoLineKey: 'p1-step',
      gateCriteriaJson:
        '{"trigger":"GalleryPurchased","conditions":[{"metric":"ItemKey","operator":"==","value":"chapel_altar"}]}',
      rewardJson: '{"collectible":"apostle_jude","cents":25000}',
      nodeX: 92,
      nodeY: 10,
      completedUtc: null,
    },
  ],
};
